/* KLAXON cleanup layer: keeps the current layouts and interactions intact. */
(function(){
  'use strict';
  function normalizeText(value){return String(value||'').replace(/\s+/g,' ').trim();}
  function hideInjectedSubscribePopup(){
    document.querySelectorAll('.popup-quickview[data-pause], .popup-newsletter[data-pause], [data-newsletter-popup], .newsletter-popup').forEach(function(el){
      if(el.closest&&el.closest('[data-klx-engagement-popup]'))return;
      var txt=normalizeText(el.textContent).toLowerCase();
      if(txt.indexOf('subscribe us')!==-1||txt.indexOf('get newsletters')!==-1||txt.indexOf('newsletter')!==-1){
        el.style.setProperty('display','none','important');el.style.setProperty('visibility','hidden','important');el.style.setProperty('pointer-events','none','important');el.setAttribute('aria-hidden','true');
      }
    });
  }
  function refreshInlineMedia(){
    var media=document.querySelector('.klx-media-stage');
    if(!media||media.dataset.klxRefreshed==='true')return;
    media.dataset.klxRefreshed='true';
    var eyebrow=media.querySelector('.klx-eyebrow'),title=media.querySelector('h2, h3'),copy=media.querySelector('p'),image=media.querySelector('img');
    if(eyebrow)eyebrow.textContent='PRODUCT VIDEOS';
    if(title)title.textContent='See KLAXON Furniture Up Close';
    if(copy)copy.textContent='Watch product details and assembly videos before you choose.';
    if(image)image.loading='lazy';
  }
  function refreshEngagementPopup(){
    var popup=document.querySelector('[data-klx-engagement-popup]');
    if(!popup||popup.dataset.klxContentRefreshed==='true')return;
    popup.dataset.klxContentRefreshed='true';
    var eyebrow=popup.querySelector('.klx-eyebrow'),title=popup.querySelector('h2'),copy=popup.querySelector('.klx-engagement__content > p'),chips=popup.querySelector('.klx-engagement__chips'),form=popup.querySelector('.klx-popup-form'),skip=popup.querySelector('.klx-engagement__skip'),visual=popup.querySelector('.klx-engagement__visual');
    if(eyebrow)eyebrow.textContent='KLAXON UPDATES';
    if(title)title.textContent='New products and useful home ideas.';
    if(copy)copy.textContent='Get new arrivals, product updates and simple ideas for making better use of your space.';
    if(chips)chips.innerHTML='<span class="klx-engagement__chip">New arrivals</span><span class="klx-engagement__chip">Product updates</span><span class="klx-engagement__chip">Room ideas</span>';
    if(form&&!popup.querySelector('.klx-engagement__actions')){
      var actions=document.createElement('div');
      actions.className='klx-engagement__actions';
      actions.innerHTML='<a class="klx-engagement__action klx-engagement__action--primary" href="/collections/all-klaxon-furniture">Browse KLAXON Furniture</a><a class="klx-engagement__action" href="#klx-rooms">Shop by Room</a>';
      form.parentNode.insertBefore(actions,form);
    }
    var submit=form&&form.querySelector('button[type="submit"]');
    if(submit)submit.textContent='Subscribe';
    if(skip)skip.textContent='Occasional updates from KLAXON. Unsubscribe at any time.';
    if(visual&&!visual.querySelector('.klx-engagement__visual-caption')){
      var caption=document.createElement('div');caption.className='klx-engagement__visual-caption';caption.innerHTML='<span>KLAXON</span><strong>Made for Modern Indian Homes</strong>';visual.appendChild(caption);
    }
  }
  function runCleanup(){hideInjectedSubscribePopup();refreshInlineMedia();refreshEngagementPopup();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',runCleanup,{once:true});else runCleanup();
  window.setTimeout(runCleanup,700);
})();
